import { css } from "@emotion/react";

export const newLabelStyle = css`
  text-align: left;
`;
